module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "500px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "addon-image"
  }), _vm._v(" "), _c('h2', [_vm._v("Köp eller ladda liftkort")]), _vm._v(" "), _c('p', [_vm._v(_vm._s('Våra liftkort är så kallade keycards. Kortet kostar 55 kr och laddas för perioden du vill åka skidor. Barn 0–6 år med hjälm åker gratis med keycard som laddas kostnadsfritt. Tips! Spara ditt keycard, det går att ladda igen vid nästa besök och fungerar både i Branäs och Kungsberget.'.replace('55', _vm.SITE_CONFIG.skipass.keycard_price)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a123326"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkipassInfo.vue
// module id = 961
// module chunks = 0